import React from 'react'
import { Box, Modal, useTheme, TextField } from '@mui/material'
import { tokens } from '../../../theme';
function CustomModal({ open, handleOpen, handleClose }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const handleSubmit = () => {
        // get the values and append it on the display
    };

    // styles 
    const style = {
        "& .modal-content": {
            backgroundColor: colors.primary[400],
            color: colors.grey[200],
        },
        "& h4": {
            color: colors.grey[100],
            paddingLeft: "0.5rem"
        },
        "& .btn-2-close .mdi-close": {
            color: colors.grey[300],
            fontSize: "22px"
        },
        "& .btn-2-close .mdi-close:hover": {
            color: colors.grey[100],

            transition: "all 0.2s ease-in"
        },
        "& input::placeholder": {
            color: `${colors.grey[500]} !important`
        },
        "& input": {
            color: `${colors.grey[100]} !important`
        }


    }
    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
            <Box
                sx={style}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myCenterModalLabel">Add New</h4>
                            <button type="button" className="btn-2-close" aria-hidden="true" onClick={handleClose}>
                                <span><i className='mdi mdi-close'></i></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="name">Task Name</label>
                                    <input type="text" required className="form-control" id="name" placeholder="e.g Send Mail to Mr. Anso" />
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label" htmlhtmlFor="assign">Assign to</label>
                                            <input type="text" required className="form-control" id="assign" placeholder="e.g Mr. Abu, CEO" />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label" htmlhtmlFor="priority">Priority</label>
                                            <input type="text" required className="form-control" id="priority" placeholder="e.g High, Medium, Low" />

                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="Sdate">Start Date</label>
                                            <input type="date" required className="form-control" id="Sdate" placeholder="" />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="Ddate">Due Date</label>
                                            <input type="date" required className="form-control" id="Ddate" placeholder="" />
                                        </div>
                                    </div>
                                </div>

                                <button type="submit" className="btn-2 btn-2-success waves-effect waves-light me-1">Save</button>
                                <button type="button"
                                    onClick={handleClose}
                                    className="btn-2 btn-2-danger waves-effect waves-light"
                                >Cancel</button>
                            </form>
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
    )
}

export default CustomModal